module.exports = __webpack_public_path__ + "media/images/flags/4x3/mtq-1270c419c8456fc71e76e3ef5f5e0c60.svg";